/**
 * UI slice for the MasterView store.
 *
 * Manages modal open/close states and pending action for confirmation dialogs.
 *
 * @internal
 * @module store/slices/uiSlice
 */
import type { StateCreator } from 'zustand';
import type { MasterPatternViewEntity } from '../../types/service.types';
import type { PendingAction } from '../../types/internal.types';
import type { MasterViewState, UIState } from '../types';

export const createUISlice = <T extends MasterPatternViewEntity>(): StateCreator<
  MasterViewState<T>,
  [],
  [],
  UIState
> => (set) => ({
  isChangeStatusModalOpen: false,
  isCompanyEnableModalOpen: false,
  isNotEnabledModalOpen: false,
  isDirtyStateDialogOpen: false,
  isImportModalOpen: false,
  isConflictDialogOpen: false,
  pendingAction: null,

  openChangeStatusModal: () => set({ isChangeStatusModalOpen: true }),
  closeChangeStatusModal: () => set({ isChangeStatusModalOpen: false }),

  openCompanyEnableModal: () => set({ isCompanyEnableModalOpen: true }),
  closeCompanyEnableModal: () => set({ isCompanyEnableModalOpen: false }),

  openNotEnabledModal: () => set({ isNotEnabledModalOpen: true }),
  closeNotEnabledModal: () => set({ isNotEnabledModalOpen: false }),

  openDirtyStateDialog: () => set({ isDirtyStateDialogOpen: true }),
  closeDirtyStateDialog: () => set({ isDirtyStateDialogOpen: false }),

  openImportModal: () => set({ isImportModalOpen: true }),
  closeImportModal: () => set({ isImportModalOpen: false }),

  openConflictDialog: () => set({ isConflictDialogOpen: true }),
  closeConflictDialog: () => set({ isConflictDialogOpen: false }),

  setPendingAction: (action: PendingAction) => set({ pendingAction: action }),
  clearPendingAction: () => set({ pendingAction: null }),

  viewMode: 'table' as const,
  setViewMode: (mode) => set({ viewMode: mode }),
});
